import React from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import LearnLayout from '../../components/learn/LearnLayout';
import ArticleRenderer from '../../components/learn/ArticleRenderer';
import PartnerTip from '../../components/learn/PartnerTip';
import RegionCallout from '../../components/learn/RegionCallout';
import { usePageMeta } from '../../hooks/usePageMeta';
import { useSsrLearnRoute } from '../../hooks/useSsrLearnRoute';
import { getArticleBySlug } from '../../content/learn/registry';

function LearnArticlePage() {
  const { slug } = useParams();
  const article = getArticleBySlug(slug);

  useSsrLearnRoute(article ? `/learn/${article.slug}` : '/learn');

  usePageMeta({
    title: article ? `${article.title} | WhoDatNumber` : 'Safety guides | WhoDatNumber',
    description: article?.description || '',
    canonicalPath: article ? `/learn/${article.slug}` : '/learn',
  });

  if (!article) {
    return <Navigate to="/learn" replace />;
  }

  const hasPartnerBlock = article.sections?.some((s) => s.type === 'partnerTip');
  const showMetaPartnerTip =
    article.partnerTip &&
    article.partnerTip !== 'none' &&
    !hasPartnerBlock;

  const related = (article.relatedSlugs || [])
    .map((s) => getArticleBySlug(s))
    .filter(Boolean);

  return (
    <LearnLayout
      title={article.title}
      description={article.description}
      guideType={article.guideType}
      readMinutes={article.readMinutes}
      breadcrumb={
        <>
          <Link to="/learn" className="hover:underline">
            Safety guides
          </Link>
          {' / '}
          <span className="text-gray-700">{article.title}</span>
        </>
      }
    >
      <ArticleRenderer sections={article.sections} />

      {showMetaPartnerTip && (
        <PartnerTip variant={article.partnerTip === 'compact' ? 'compact' : 'primary'} />
      )}

      {related.length > 0 && (
        <section className="mt-10">
          <h2 className="text-lg font-bold text-gray-900 mb-3">Related guides</h2>
          <ul className="space-y-2">
            {related.map((r) => (
              <li key={r.slug}>
                <Link
                  to={`/learn/${r.slug}`}
                  className="text-blue-600 hover:underline"
                >
                  {r.title}
                </Link>
              </li>
            ))}
          </ul>
        </section>
      )}

      <RegionCallout />
    </LearnLayout>
  );
}

export default LearnArticlePage;

